import { NavigationState, StoreAction } from '../types';

export const NAVIGATION_INIT_STATE: NavigationState = {
    contentHeight: undefined,
    currentPage: undefined,
    menus: undefined,
    currentSchool: undefined,
    sponsors: undefined,
    destinations: undefined,
    generalMedia: undefined,
};

export const TYPE_NAVIGATION_CHANGE_MENUS = ('NAVIGATION_TYPE_NAVIGATION_CHANGE_MENUS');
export const TYPE_NAVIGATION_CHANGE_CURRENT_SCHOOL = ('NAVIGATION_TYPE_NAVIGATION_CHANGE_CURRENT_SCHOOL');
export const TYPE_NAVIGATION_CHANGE_CURRENT_PAGE = ('NAVIGATION_TYPE_NAVIGATION_CHANGE_CURRENT_PAGE');
export const TYPE_NAVIGATION_CHANGE_CONTENT_HEIGHT = ('NAVIGATION_TYPE_NAVIGATION_CHANGE_CONTENT_HEIGHT');
export const TYPE_NAVIGATION_CHANGE_SPONSORS = ('NAVIGATION_TYPE_NAVIGATION_CHANGE_SPONSORS');
export const TYPE_NAVIGATION_CHANGE_DESTINATIONS = ('NAVIGATION_TYPE_NAVIGATION_CHANGE_DESTINATIONS');
export const TYPE_NAVIGATION_CHANGE_GENERAL_MEDIA = ('NAVIGATION_TYPE_NAVIGATION_CHANGE_GENERAL_MEDIA');
export const ERROR_UNDEFINED = ('NAVIGATION_ERROR_UNDEFINED');

export const navigation = (state: NavigationState = NAVIGATION_INIT_STATE, action: StoreAction = { type: ERROR_UNDEFINED, error: 'notFoundAction' }) => {
    switch (action.type) {
        case TYPE_NAVIGATION_CHANGE_CURRENT_SCHOOL:
            return {
                ...state,
                currentSchool: action.data,
            };
        case TYPE_NAVIGATION_CHANGE_MENUS:
            return {
                ...state,
                menus: action.data,
            };
        case TYPE_NAVIGATION_CHANGE_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.data,
            };
        case TYPE_NAVIGATION_CHANGE_CONTENT_HEIGHT:
            return {
                ...state,
                contentHeight: action.data,
            };
        case TYPE_NAVIGATION_CHANGE_SPONSORS:
            return {
                ...state,
                sponsors: action.data,
            };
        case TYPE_NAVIGATION_CHANGE_DESTINATIONS:
            return {
                ...state,
                destinations: action.data,
            };
        case TYPE_NAVIGATION_CHANGE_GENERAL_MEDIA:
            return {
                ...state,
                generalMedia: action.data,
            };
        case ERROR_UNDEFINED:
            return state;
        default:
            return state;
    }
};
